<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Draggable from 'vuedraggable';
import {
  usePinnedSidebarItems,
  pickPinnedItems,
} from 'dashboard/composables/usePinnedSidebarItems';
import { useSidebarContext } from './provider';
import SidebarPinnedItem from './SidebarPinnedItem.vue';

const props = defineProps({
  // Todos os itens fixáveis do menu (ver `flattenPinnableItems`)
  items: { type: Array, required: true },
  collapsed: { type: Boolean, default: false },
});

const { t } = useI18n();
const { isAllowed } = useSidebarContext();
const { pinnedKeys, reorder } = usePinnedSidebarItems();

// Itens excluídos, sem permissão, sem feature flag ou ocultos do menu não aparecem
const visibleItems = computed(() =>
  pickPinnedItems(pinnedKeys.value, props.items).filter(item =>
    isAllowed(item.to)
  )
);

const onReorder = reorderedItems => reorder(reorderedItems.map(i => i.key));
</script>

<template>
  <section
    v-if="visibleItems.length"
    class="grid gap-1 pb-2 mb-1 border-b border-n-weak"
  >
    <p v-if="!collapsed" class="px-2 m-0 text-xs font-medium text-n-slate-10">
      {{ t('SIDEBAR.PINNED_ITEMS') }}
    </p>
    <Draggable
      :model-value="visibleItems"
      tag="ul"
      item-key="key"
      class="grid gap-0.5 m-0 overflow-y-auto list-none max-h-60"
      :class="{ 'justify-items-center': collapsed }"
      @update:model-value="onReorder"
    >
      <template #item="{ element }">
        <SidebarPinnedItem :item="element" :collapsed="collapsed" />
      </template>
    </Draggable>
  </section>
</template>
